//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"Position",0,"Expression",0],[0,"ProcessType",1,0]],[[["value"],"SetStrokeDistance",{},1,0],[[],"DeleteExplosion",{},0,0],[[],"ShowExplosion",{},0,0],[[],"HideExplosion",{},0,0],[[],"TransformExplosionShadowPatrs",{},0,0],[["valuatorName","value"],"UpdateMotionValuators",{},2,0]],[]];
SPLM.Tooling.ExplosionSimulationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ExplosionSimulationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ExplosionSimulationBuilder.ProcessTyps = Object.freeze({
    "OpenProcess" : "OpenProcess", "CloseProcess" : "CloseProcess"});

export default SPLM;